import styled from 'styled-components';

const Block = styled.div`
  display: flex;
  margin: 5px 0;
`;

export default Block;
